var map = {
	"./angle.svg": 7576,
	"./calendar.svg": 7741,
	"./chart.svg": 4553,
	"./check.svg": 437,
	"./clock.svg": 3335,
	"./cross.svg": 4297,
	"./document.svg": 6532,
	"./dollar.svg": 1901,
	"./email.svg": 2453,
	"./home.svg": 6618,
	"./logout.svg": 8617,
	"./payment-of-request.svg": 9571,
	"./pie-chart.svg": 2752,
	"./preloader.svg": 6267,
	"./repeat.svg": 6294,
	"./replenish.svg": 4643,
	"./telegram.svg": 6994,
	"./wallet.svg": 8076,
	"./whatsapp.svg": 6325
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | iconsChunk */ 8634).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1156;
module.exports = webpackAsyncContext;